import React from 'react';
import * as util from "../other/util.js";
import FleetTaskEditor from "./fleet/tasks/fleet-task-editor.js"
import FleetSelector from "./fleet/util/fleet-selector.js"
import FleetStatistics from "./fleet/util/fleet-statistics.js"
import { GameData } from "../share/game-data.js"
import * as Backend from "../backend.js";
import FleetTaskFactory from "./fleet/tasks/fleet-task-factory.js";
import ShipCollection from "../share/ship-collection.js"
import config from './../config.js';

// Shows the player all ships stationed on the planet
class PlanetShipDockView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tasks: [FleetTaskFactory.createTask("LAUNCH", true, 0)],
            fleet: new ShipCollection(),
        };

        // We add these here because usually a ShipCollection does not have these properties,
        // but the FleetTaskEditor and FleetStatistics views expect it
        // let location = util.extractCoordinates(this.props.planet); XXX: can we use this instead of the mess below
        this.state.fleet.name = util.getRandomFleetName();
        this.state.fleet.location = util.extractCoordinates(this.props.planet);
        this.state.fleet.location.name = this.props.planet.name;
        this.state.fleet.location.owner_id = this.props.planet.owner_id;
        this.state.fleet.location.owner_name = this.props.planet.owner_name;
        this.state.fleet.resources = GameData.getEmptyResourceVector();

        // Add some fuel
        if (config.debug) {
            this.state.tasks[0].resources.fuel = 10;
        }
    }

    render() {
        let planet = this.props.planet;

        if (!planet) {
            return (<util.LoadingBar thing={planet} thingName="ships" />);
        }

        if (planet.stationed_ships.empty()) {
            return (<div><h2>Stationed Ships</h2><p>No ships stationed here.</p></div>);
        }

        return (
            <div>
                <h2>Ship Dock</h2>
                <div style={{ display: "flex" }}>
                    {/* The fleet name and composition */}
                    <div style={{ flex: "50%" }}>
                        <h4>Selected Ship</h4>
                        <p className="boring-info-text">Choose ships and assign tasks to form a new fleet.</p>
                        <util.KeyValueInput label="Fleet designation"
                            value={this.state.fleet.name}
                            checks={["NOT_EMPTY"]}
                            onChange={(event) => this._handleFleetNameChange(event)}
                            maxLength={50}
                            width={"50%"} />
                        <div>
                            <FleetSelector available={planet.stationed_ships}
                                selected={this.state.fleet}
                                onChange={(new_fleet) => this._handleFleetUpdate(new_fleet)} />
                        </div>
                    </div>

                    {/* The fleets statistics */}
                    <div style={{ flex: "50%" }}>
                        <FleetStatistics fleet={this.state.fleet} />
                    </div>
                </div>

                {/* Task list */}
                <FleetTaskEditor tasks={this.state.tasks}
                    mode={"LAUNCHING"}
                    fleet={this.state.fleet}
                    resources={this.state.resources}
                    onUpdateTaskArray={(tasks) => this._handleUpdateTaskArray(tasks)} />

                {/* Launch button */}
                <div className="action-button"
                    style={{ float: "right" }}
                    onClick={() => this._handleLaunchRequest()}>Launch
                </div>
                <util.JsonDebug obj={this.state.fleet} />
            </div>
        );
    }

    _handleFleetNameChange(value) {
        let fleet = new ShipCollection(this.state.fleet);
        fleet.name = value;
        this.setState({ fleet: fleet });
    }

    _handleUpdateTaskArray(tasks) {
        this.setState({ tasks: tasks });
    }

    _handleFleetUpdate(new_fleet) {
        this.setState({
            fleet: new_fleet,
        });
    }

    _handleLaunchRequest() {
        let name = this.state.fleet.name;
        let selected_ships = {};
        this.state.fleet.forEach(ship_type => selected_ships[ship_type.design.id] = ship_type.count);
        let tasks = this.state.tasks;
        let x = this.props.planet.x;
        let y = this.props.planet.y;
        let z = this.props.planet.z;

        Backend.tryLaunchFleet(x, y, z, name, selected_ships, tasks, (res) => {
            if (res.success) {
                this.props.navigate('/game/fleet-overview');
            } else {
                alert(res.error);
            }
        });
    }
}

export default util.withNavigation(PlanetShipDockView);